import { ApiRoutingUtils } from '@/Routing';
import {
  CreateGeneratorProductRequest,
  CreateGeneratorProductResponse,
  UpdateGeneratorProductRequest,
  UpdateGeneratorProductResponse,
  GenerateUserProductResponse,
  GetGeneratorProductsResponse,
} from '.';
import { rest } from '@/Api/Rest';
import { GetGeneratorProductsRequest } from '@/Api/GeneratorProducts/GetGeneratorProductsRequest';
import { GetProductStatusesResponse } from '@/Api/GeneratorProducts/GetProductStatusesResponse';

const url = ApiRoutingUtils.createUrl('generator-products');

async function getGeneratorProducts(request: GetGeneratorProductsRequest): Promise<GetGeneratorProductsResponse> {
  return rest.get(url, request);
}

async function createGeneratorProduct(request: CreateGeneratorProductRequest): Promise<CreateGeneratorProductResponse> {
  return rest.post(url, request);
}

async function updateGeneratorProduct(request: UpdateGeneratorProductRequest): Promise<UpdateGeneratorProductResponse> {
  return rest.put(url, request);
}

async function deleteGeneratorProduct(id: number): Promise<number> {
  return rest.delete(`${url}/${id}`, null);
}

async function generateProducts(id: number): Promise<GenerateUserProductResponse> {
  return rest.post(`${url}/generate/${id}`, null);
}

async function getProductStatuses(): Promise<GetProductStatusesResponse> {
  return rest.get(`${url}/statuses`);
}

export const GeneratorProductsApi = {
  getGeneratorProducts,
  createGeneratorProduct,
  updateGeneratorProduct,
  deleteGeneratorProduct,
  generateProducts,
  getProductStatuses,
};
